























import Vue, { PropOptions } from 'vue'
import {
  GlobalHeader as GlobalHeaderModule,
  CurrentUser,
  AccountMenuItem,
  MenuBarItem
} from '@raksul/raksul-common-ui'
import { browser } from '@/common/userAgent'
import NavBarItem  from '@/common/components/globalHeader/NavBarItem.vue'
import HeaderSearch from '@/common/components/globalHeader/HeaderSearch.vue'
import { CommonAppData } from '@/common/types/commonAppData'

export default Vue.extend({
  components: {
    GlobalHeaderModule,
    NavBarItem,
    HeaderSearch
  },
  props: {
    orderHistoryCount: {
      type: Number,
      default: 0
    },
    currentUser: {
      validator: v => typeof v === 'object' || v === null,
      required: true
    } as PropOptions<CurrentUser>,
    applicationData: {
      type: Object,
      required: true
    } as PropOptions<CommonAppData>
  },
  computed: {
    raksulHostname(): string {
      return this.applicationData.raksul_core_url
    },
    accountMenuItems(): AccountMenuItem[] {
      return [
        {
          label: 'メールアドレスの変更',
          handler: (event: MouseEvent) => {
            event.preventDefault()
            this.openLinkUrl('/account/settings/email')
          }
        },
        {
          label: 'パスワードを変更',
          handler: (event: MouseEvent) => {
            event.preventDefault()
            this.openLinkUrl('/account/settings/password')
          }
        },
        {
          label: 'メールマガジンの配信設定',
          handler: (event: MouseEvent) => {
            event.preventDefault()
            this.openLinkUrl('/account/settings/mail_magazine')
          }
        },
        {
          label: 'クレジットカードの追加・削除',
          handler: (event: MouseEvent) => {
            event.preventDefault()
            this.openLinkUrl('/mypage/account/card')
          }
        },
        {
          label: '出荷元の追加・削除',
          handler: (event: MouseEvent) => {
            event.preventDefault()
            this.openLinkUrl('/mypage/account/sender')
          }
        },
        {
          label: 'お届け先の追加・削除',
          handler: (event: MouseEvent) => {
            event.preventDefault()
            this.openLinkUrl('/mypage/account/recipient')
          }
        }
      ]
    },
    menuBarItemsData(): MenuBarItem[] {
      return [
        {
          icon: 'help',
          link: '/estimate'
        },
        {
          icon: 'cart',
          badgeCount: this.applicationData.cart_count,
          link: '/cart'
        }
      ]
    },
    isIE(): boolean {
      return browser.isIE
    }
  },
  methods: {
    signIn(): void {
      window.location.href = '/login'
    },
    signOut(): void {
      window.location.href = '/logout'
    },
    openLinkUrl(path:string){
      window.open(
        `${this.raksulHostname}` + path,
        this.isIE ? '_self' : '_blank',
        this.isIE ? '' : 'noreferrer noopener'
      )
    }
  }
})
